import React from 'react';

function LiveChatTracking(WrappedComponent) {
  return class extends React.Component {
    state = {
      are_agents_available: false,
      chat_hidden: true
    };

    componentDidMount() {
      const { license, group } = this.props.match.params;

      window.__lc = window.__lc || {};
      window.__lc.license = license;
      window.__lc.test = 1;
      group && (window.__lc.group = group);

      let labs = '';
      if (document.location.host !== 'quality.livechatinc.com' && document.location.host !== 'quality.text.com') {
        window.__lc.hostname = 'secure-labs.livechatinc.com';
        window.__lc.chat_absolute_url =
          document.location.protocol +
          '//source.livechatinc.com/preview/labs1/chat.html';
        labs = 'labs/';
      }

      const lc = document.createElement('script');
      lc.type = 'text/javascript';
      lc.async = true;
      lc.src =
        ('https:' === document.location.protocol ? 'https://' : 'http://') +
        `cdn.livechatinc.com/${labs}tracking.js`;
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(lc, s);
      window.LC_API = window.LC_API || {};

      window.LC_API.on_after_load = () => {
        if (window.LC_API.agents_are_available()) {
          this.setState({ are_agents_available: true });
        }

        if (!window.LC_API.chat_window_hidden()) {
          this.setState({ chat_hidden: false });
        }
      };
    }

    render() {
      const { license, group } = this.props.match.params;
      return (
        <WrappedComponent license={license} group={group} {...this.state} />
      );
    }
  };
}
export default LiveChatTracking;



// WEBPACK FOOTER //
// ./src/containers/LiveChatTracking.js